import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmprojectpositionprojectitem/cecUnmProjectPositionProjectItem/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmprojectpositionprojectitem/cecUnmProjectPositionProjectItem/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmprojectpositionprojectitem/cecUnmProjectPositionProjectItem/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmprojectpositionprojectitem/cecUnmProjectPositionProjectItem/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmprojectpositionprojectitem/cecUnmProjectPositionProjectItem/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmprojectpositionprojectitem/cecUnmProjectPositionProjectItem/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmprojectpositionprojectitem/cecUnmProjectPositionProjectItem/import',
      method: 'post',
      data: data
    })
  }
}
